import { render, staticRenderFns } from "./ValidationDetails.vue?vue&type=template&id=ca0a3462&scoped=true&"
import script from "./ValidationDetails.vue?vue&type=script&lang=js&"
export * from "./ValidationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ValidationDetails.vue?vue&type=style&index=0&id=ca0a3462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0a3462",
  null
  
)

export default component.exports